import React from 'react';
import { motion } from 'framer-motion';
import { useCvData } from '../context/CvDataContext.js';
import MediaGallery from './MediaGallery.js';
import './Patents.css';

const Patents = () => {
  const { patents, loading, error, reload } = useCvData();
  if (error) return (
    <section className="patents-section" id="patents">
      <h2>Patents</h2>
      <p role="alert">{error.message || 'Failed to load.'}</p>
      <button onClick={reload} className="retry-btn">Retry</button>
    </section>
  );
  if (loading) return (
    <section className="patents-section" id="patents">
      <h2>Patents</h2>
      <ul className="patents-list">
        {[...Array(4)].map((_, idx) => (
          <li key={idx} className="patent-item">
            <div className="patent-content">
              <div className="patent-header">
                <div className="skeleton skeleton-text lg" style={{ width: '70%' }} />
              </div>
              <div className="patent-meta">
                <span className="skeleton skeleton-text" style={{ width: 140 }} />
                <span className="skeleton skeleton-text" style={{ width: 90 }} />
                <span className="skeleton skeleton-text" style={{ width: 120 }} />
              </div>
              <div className="skeleton skeleton-rect" style={{ marginTop: 12 }} />
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
  if (patents.length === 0) return null;
  return (
    <section className="patents-section" id="patents">
      <h2>Patents</h2>
      <ul className="patents-list">
        {patents.map((patent, index) => (
          <motion.li
            key={patent.id}
            className="patent-item"
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{
              duration: 0.6,
              delay: index * 0.1,
              type: "spring",
              stiffness: 100,
              damping: 15
            }}
            whileHover={{
              scale: 1.02,
              transition: { duration: 0.2 }
            }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="patent-bulb" aria-hidden="true">💡</span>
            {patent.url ? (
              <a href={patent.url} target="_blank" rel="noopener noreferrer" className="patent-card-link">
                <div className="patent-content">
                  <div className="patent-header">
                    <h3 className="patent-title">{patent.title}</h3>
                  </div>
                  <div className="patent-meta">
                    {patent.number && <span className="patent-number">{patent.number}</span>}
                    {patent.status && <span className={`patent-badge ${patent.status === 'Granted' ? 'granted' : 'published'}`}>{patent.status}</span>}
                    {patent.issued && <span className="patent-issued">{patent.issued}</span>}
                  </div>
                  {(patent.media.images.length > 0 || patent.media.videos.length > 0) && (
                    <div className="patent-media">
                      <MediaGallery media={patent.media} />
                    </div>
                  )}
                </div>
              </a>
            ) : (
              <div className="patent-content">
                <div className="patent-header">
                  <h3 className="patent-title">{patent.title}</h3>
                </div>
                <div className="patent-meta">
                  {patent.number && <span className="patent-number">{patent.number}</span>}
                  {patent.status && <span className={`patent-badge ${patent.status === 'Granted' ? 'granted' : 'published'}`}>{patent.status}</span>}
                  {patent.issued && <span className="patent-issued">{patent.issued}</span>}
                </div>
                {(patent.media.images.length > 0 || patent.media.videos.length > 0) && (
                  <div className="patent-media">
                    <MediaGallery media={patent.media} />
                  </div>
                )}
              </div>
            )}
          </motion.li>
        ))}
      </ul>
    </section>
  );
};

export default Patents;
